import { debounce } from 'lodash-es';
const canvaLoadImage =function(url,canva){
    const img = new Image();
    img.src = url;
    img.onload = function () {
        canva.width = img.width;
        canva.height = img.height;
        canva.getContext("2d").drawImage(img, 0, 0);
    }
    return img;

}

/**
 * 16进制颜色转&HBGR
 * @param {*} color 
 * @returns 
 */
export function colorTobga(color, alpha?) {
    if (!color) return color
    const str = color.split('#')[1]
    const strList = []
    if (!str) return color
    str.match(/.{2}/g).forEach((item) => {
        strList.push(item); // 将子字符串添加到数组中
    })
    if (alpha) {
      return `&H${opacityToHex(1-alpha)}${strList[strList.length - 1]}${strList[strList.length - 2]}${strList[strList.length - 3]}`
    } else {
      return `&H${strList[strList.length - 1]}${strList[strList.length - 2]}${strList[strList.length - 3]}`
    }
    
}

/**
 * 透明度转16进制
 * @param {*} opacity 
 * @returns 
 */
function opacityToHex(opacity) {
  let hex = Math.round(opacity * 255).toString(16);
  if (hex.length === 1) {
    hex = "0" + hex; // 在单个字符的情况下，在前面补0
  }
  return hex;
}

export function bgaToColor(color) {
  if (!color) return ''
  const str = color.split('&H')[1]
  if (!str) return color;
  const strList = []
  str.match(/.{2}/g).forEach((item) => {
    strList.push(item); // 将子字符串添加到数组中
  })
  return `#${strList[strList.length - 1]}${strList[strList.length - 2]}${strList[strList.length - 3]}`
  
}

/**
 * 16进制转rgba
 * @param {*} color 
 * @returns #ffffff
 */
export function colorTorgba(hex, alpha) {
  if (!hex) return ''
  const color = hex.replace("#", "");
  // 分割成RGB三部分
  const r = parseInt(color.substring(0,2), 16);
  const g = parseInt(color.substring(2,4), 16);
  const b = parseInt(color.substring(4,6), 16);
  if (Number(alpha) >= 0) {
    return  `rgba(${r},${g},${b}, ${alpha})`
  }
  return `rgb(${r},${g},${b})`
}
/**
 * 对比差异
 * @param {*} obj1 
 * @param {*} obj2 
 * @returns 
 */
export function compareObjects(obj1, obj2) {
    try {
        let diff = [];
        
        function compareProps(obj1, obj2, path = '') {
        for (let key in obj1) {
            if (typeof obj2[key] === 'undefined') {
            diff.push(path + key);
            } else if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
              if (Array.isArray(obj1[key])) {
                if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
                  diff.push(path + key);
                }
              } else {
                compareProps(obj1[key], obj2[key], path + key + '.');
              }
            
            } else if (obj1[key] !== obj2[key]) {
            diff.push(path + key);
            }
        }
        }
        
        compareProps(obj1, obj2);
        return diff;
    } catch (error) {
        return []
    }
  }

  export function insertChar(str, index, char) {
    if (index > str.length) {
      return str + char;
    } else if (index < 0) {
      return char + str;
    } else {
      return str.slice(0, index) + char + str.slice(index);
    }
  }

  /**
   * 字体名字
   * @param nameEn 
   * @returns 
   */
  export function fontNameEn(nameEn) {
    if (!nameEn) return ''
    nameEn = nameEn.replace(/\s+/g, '_')
    nameEn = nameEn.replace(/\./g, '_')
    if(/^\d/.test(nameEn)) nameEn = 'f_' + nameEn; // 以数字开头的字体命名有问题，增加前缀
    return nameEn
  }
  export const debouncedSaveArticle = debounce(function (that) {
    that.$bus.$emit(that.$EventBusKey.REQUEST_SAVE_ARTICLE)
	}, 500)
  export const debouncedSaveData = debounce(function (that) {
    that.$bus.$emit(that.$EventBusKey.SAVE_DATA)
	}, 500)

  /**
		 * 处理对比的数据
		 * @param diffList
		 * @returns 
		 */
  export function handleDiffList(diffList, newText) {
    let prevDiffInfo:any = {}
    const diffTextList = []
    console.log('handleDiffList-diffList', diffList)
    diffList.forEach((item, index) => {
      const preIndex = diffTextList.findIndex(info => info === prevDiffInfo)
      const oldVal = JSON.parse(JSON.stringify(prevDiffInfo)).value
      if (item.added && prevDiffInfo.removed) {
        diffTextList.splice(preIndex, 1)
        diffTextList.push({
          replaced: true,
          highlight: 'replaced',
          value: item.value,
          oldVal,
          text: newText
        })
      } 
      else if(item.added) {
        diffTextList.push({
          replaced: true,
          highlight: 'add',
          value: item.value,
          oldVal: '',
          newVal: item.value,
          text: newText
        })
      } 
      else if (item.removed && (!diffList[index + 1] || !diffList[index + 1].added)) {
        console.log('handleDiffList-index', index)
        if (index === 0) {
          const info = diffList[index + 1]
          const preWord = info && info.value ? info.value[0] : ''
          diffTextList.push({
            replaced: true,
            highlight: 'remove',
            value: preWord,
            oldVal: item.value + preWord,
            newVal: '',
            removeVal: item.value,
            type: 'reverse',
            text: newText
          })
          info.value = info.value.substr(1,  info.value.length)
        } else {
          const lastWord = oldVal ? oldVal[oldVal.length - 1] : ''
          diffTextList.push({
            replaced: true,
            highlight: 'remove',
            value: lastWord,
            oldVal: lastWord + item.value,
            newVal: '',
            removeVal: item.value,
            type: 'sequence',
            text: newText
          })
          const info = diffTextList[preIndex]
          if (info && info.value) {
            info.value = info.value.substr(0, info.value.length - 1)
          }
        }
        
      } 
      else {
        diffTextList.push(item)
      }
      prevDiffInfo = item
    })
    // diffTextList.forEach((item, index) => {
    //   if (item.removeVal) {
    //     diffTextList.splice(index - 1, 1)
    //   }
    // })
    return diffTextList
  }

// url替换为cdn地址
export function changeUrl2Cdn(url) {
  if (!url) return '';
  const repalceMap = {
    'https://tc-nj-yuan365-pub-1324023246.cos.ap-nanjing.myqcloud.com': 'https://tc-nj-yuan365-pub-cdn.mobvoi.com', // 当前推文图片地址未使用cdn加速，进行替换
    'http://mobvoi-backend-public.ufile.ucloud.cn': 'https://tc-nj-backend-pub-cdn.mobvoi.com', // 历史上传oss图片返回路径，已经迁移到cdn
    'https://mobvoi-digitalhuman-public.cn-bj.ufileos.com/sdxl': 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl', // 历史推文图片，已经迁移到cdn
  }
  for (const key in repalceMap) {
    if (url.indexOf(key) === 0) {
      return url.replace(key, repalceMap[key]);
    }
  }
  return url;
}